import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { debounce } from 'lodash';
import ClearIcon from '../../components/icons/ClearIcon';

const CloseButton = styled.button`
    height: fit-content;
    padding: 5px;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
    cursor: pointer;
    outline: none;
    position: absolute;
    z-index: 2;
    right: 8px;
    top: 0;
    bottom: 0;
    margin: auto;
`

const FabricSearch = ({ onSearch, term }) => {

    const [value, setValue] = useState(term || '')

    const debounceSearch = debounce(onSearch, 500);

    const onChange = (value) => {
        setValue(value);
        debounceSearch(value);
    }

    const onClear = () => {
        setValue('');
        debounceSearch('');
    }

    return (
        <div className='b-rit-search'>
            <input
                className='b-rit-input'
                value={value}
                onChange={(e) => onChange(e.target.value)}
                type='search'
                placeholder='Поиск'
            />
            {value &&
                <CloseButton
                    onClick={onClear}>
                    <ClearIcon style={{width:'1em', height:'1em'}} />
                </CloseButton>
            }
        </div>
    )
}

FabricSearch.propTypes = {
    onSearch: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
    term: PropTypes.string,
}

export default FabricSearch;